export const baseURL =
  process.env.REACT_APP_BASE_GDD_VENDORS_SERVICE_URL ||
  "http://demos4.obvio.com.co:3200";
